module.exports = __webpack_public_path__ + "static/media/banner_dem_data.671c5be9.jpg";